import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import apiConfig from "../utils/apiConfig";
import { IEbayMessagingStatsResponse } from "../models/EbayMessage";

interface UseEbayMessagingStatsProps {
  daysToSearch: number;
}

export default function useEbayMessagingStats(
  { daysToSearch }: UseEbayMessagingStatsProps,
  componentName = "useEbayMessagingStats"
) {
  const { get } = useApiHelper(apiConfig(componentName));

  const messagingStats = useQuery({
    queryKey: ["ebayMessagingStats", daysToSearch],
    queryFn: () =>
      get<IEbayMessagingStatsResponse>(
        `/ebaymessaging/stats?daysToSearch=${daysToSearch}`
      ),
    // Endpoint is pending (see docs/pending-endpoints.md) — avoid the
    // flash of LoadingWheel every focus/retry while we wait for it.
    staleTime: 1000 * 60 * 5,
    retry: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });

  return {
    messagingStats,
  };
}
